<template>
  <a-layout class="gmain">
    <a-layout class="gheader">
      <Home
        :d="accountList"
        :m="currentAccount"
        :showPage="showHeader"
        @accountChange="accountChange"
        ref="gheader"
      ></Home>
    </a-layout>
    <!-- <audio id="js-gheader-audio" muted src="https://s2.ssl.qhres2.com/static/b7322bf9e6fcad5f.mp3"></audio> -->
    <a-modal title="账号不存在" v-model="alertShow">
      <template slot="footer">
        <a-button @click="alertHandleCancel" key="back">重新登录</a-button>
      </template>
      <p>
        您无权访问视图计算平台，请联系管理员加入已有企业或前往
        <a href="https://zyun.360.cn/enterprise/znjk">智汇云官网</a>
        开通试用账号
      </p>
    </a-modal>
  </a-layout>
</template>
<script>
import Home from './main/Home.vue'
import gheader from './main/header'
import global from '../utils/Global'

export default {
  components: {
    gheader,
    Home
  },
  data () {
    return {
      alertShow: false,
      showHeader: false,
      isLogin: false,
      deviceTypes: null,
      accountList: [],
      currentAccount: null,
      showTip: false,
      id: 0,
    }
  },
  created () {
    // 切换账号、浏览器前进后退时加载子菜单
    this.$nextTick(() => {
      this.$refs.gheader.getDeviceTypes()
    })
  },
  mounted () {
    if (this.$router.name == 'login') {
      return
    }
    var that = this
    if (!global || !global.userInfo) {
      // QHPass.signOut(function () {
      //   that.gotoLoginPage()
      // })
      return this.logOut()
    }
    that.onresizeHander()
    window.onresize = function () {
      that.onresizeHander()
    }
    this.gotoPage()
  },
  methods: {
    // 退出登录
    logOut (res) {
      global.logOut(this, res)
    },
    alertHandleCancel () {
      this.logOut()
      // this.gotoLoginPage()
    },
    gotoPage () {
      document.cookie = '__guid=16374573.1463472062757693400.1671183309848.736; __huid=117VDd6s/GRxN4QRgUtdOJZM1J7ec2yH7vCyPSfyuGqyU=; Q=u%3D360H3131815217%26n%3D%26le%3D%26m%3DZGtmWGWOWGWOWGWOWGWOWGWOZQZl%26qid%3D3131815217%26im%3D1_t0105d6cf9b508f72c8%26src%3Dpcw_aimonitor%26t%3D1; Qs_lvt_440882=1671183310%2C1671443587%2C1671516974%2C1671558106%2C1671589662; Qs_pv_440882=3151240647039063600%2C317738192896677250%2C3260391406103004700%2C3760615977568385000%2C4126963523671829000; test_cookie_enable=null';
      var qid = global.getCookie('main_header_account')
      if (!global.qid) {
        global
          .axios(this, global.ajaxAdd.checkUser, {
            account_qid: global.userInfo.qid,
          })
          .then((res) => {
            console.log(res)
            $('.html-loading').fadeOut('fast')
            global.accountList = res.data
            this.accountList = res.data
            var user_data = null
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].qid == qid) {
                user_data = res.data[i]
                break
              }
            }
            if (res.data.length > 0) {
              if (!user_data) {
                user_data = res.data[0]
              }
              global.user_level = user_data.user_level
              global.qid = user_data.qid
              this.currentAccount = global.qid
              this.showHeader = true
            } else {
              //   this.alertShow = true;
              global.msg(this, '账号不存在', 'error')
              // this.gotoLoginPage()
              this.logOut()
            }
          })
          .catch((e) => {
            $('.html-loading').fadeOut('fast')
            this.logout(e)
          })
      } else {
        this.currentAccount = qid || global.qid
        this.accountList = global.accountList
        this.showHeader = true
      }
    },
    gotoLoginPage (res) {
      global.isJumpingToLogin = null
      global.userInfo = null
      global.qid = null
      global.gotoLoginPage(this, res)
    },
    requestAddUser (callback) {
      var that = this
      var reqData = {
        qid: global.userInfo.qid,
        from_saas: 1,
      }
      var postData = md5(global.getKV(global.ksort(reqData)) + global.xiaoanKey)

      this.$axios({
        method: 'post',
        baseURL: '/api',
        url: global.ajaxAdd.addUser,
        data: that.$qs.stringify(reqData),
        headers: {
          Authorization: postData,
        },
      })
        .then(function (d) {
          if (d && d.status == 200 && d.data) {
            if (d.data.errno == 0) {
              if (callback) {
                callback()
              }
            } else if (d.data.errno == 500005) {
              window.location.href =
                'https://zyun.360.cn/console/usercenter/qualification'
            } else {
              global.msg(that, d.data.errmsg, 'error')
            }
          } else {
            global.msg(that, '查询用户状态返回异常1', 'error')
          }
        })
        .catch(function (e) {
          global.msg(that, '查询用户状态返回异常2', 'error')
        })
      return
    },
    accountChange () {
      global.setCookie('main_header_account', global.qid)
      // const path = this.$route.query
      // this.$router.push({
      //   path,
      // })
      this.reload()
    },
    getDeviceTypes () {
      var that = this
      global
        .axios(this, global.ajaxAdd.getProductList, {
          account_qid: global.userInfo.qid,
          qid: global.qid,
        })
        .then((res) => {
          that.deviceTypes = res.data
          clearInterval(this.timer)
          //   this.timer = setInterval(() => {
          // that.getEventCount();
          //   }, 3000);
        })
        .catch((e) => {
          this.logout(e)
        })
    },
    getEventCount () {
      var pid = this.deviceTypes[1].product_id
      var d = {
        product_id: pid,
        account_qid: global.userInfo.qid,
        qid: global.qid,
      }
      global
        .axios(this, global.ajaxAdd.getEventCount, d)
        .then((res) => {
          this.createItem(res.data)
        })
        .catch((e) => {
          this.logout(e)
        })
    },
    logout (e) {
      if (e.data.errno == 700004 || e.data.errno == 700003) {
        this.logOut(e)
      }
    },
    onClose (e) {
      // console.log('click', e)
    },
    onresizeHander () {
      if (this.$refs.gheader) {
        this.$refs.gheader.resize()
      }
    },
  },
  inject: ['reload'],
}
</script>

<style>
body {
  font-size: 16px !important;
}
.ant-notification-notice-close {
  right: 10px !important;
  color: #fff !important;
}

.ant-notification {
  margin: 0 !important;
  width: auto !important;
}
.ant-notification-notice.ant-notification-notice-closable {
  background: rgba(255, 0, 85, 0.8) !important;
  border-radius: 16px 0 0 16px !important;
  padding: 4px 10px !important;
}
.ant-btn.ant-btn-link.ant-btn-sm,
.ant-notification-notice-btn {
  line-height: 40px !important;
  height: 40px !important;
  color: #fff !important;
  font-size: 20px !important;
  font-weight: bold !important;
  padding: 0 10px 0 24px !important;
  margin: 0 !important;
}

.ant-notification-notice-btn {
  background: url(https://p5.ssl.qhimg.com/t01d7fa69f8d092c7c0.png) no-repeat
    4px center;
  background-size: 32px 30px;
}
.ant-notification-notice-message {
  display: none !important;
}
.ant-table-wrapper .ant-btn.ant-btn-link.ant-btn-sm {
  font-size: 14px !important;
  color: #1890ff !important;
  font-weight: normal !important;
}
.ant-notification.ant-notification-topRight {
  top: 60px;
}
.gmain,
.gheader {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/main.vue